<template>
  <main>
    <FullLoader :loading="loading"/>
    <div class="container">
      <div class="mobile create-prize-btn" :style="{opacity: loading ? 0 : 1}">
        <button class="btn btn-primary" @click="createPrizeScreen()">Create Prize</button>
      </div>
      <div class="row">
        <div
          class="col-12 d-flex justify-content-between align-items-center page-header"
          :style="{opacity: loading ? 0 : 1}"
        >
          <a
            class="header-action"
            :href="this.gevmeLink"
            data-toggle="tooltip"
            title="Back to GEVME!"
          >
            <img class="header-action back" src="@/assets/images/arrow-left.svg">
          </a>
          <h1>
            {{this.eventDetail.name}}
            <img
              class="path-separator"
              src="@/assets/images/path_separator.svg"
            >
            <!-- <span>Prizes</span> -->
            <span class="dropdown">
              <button
                class="btn dropdown-toggle"
                style="padding: 0"
                type="button"
                data-toggle="dropdown"
              >
                {{this.prizeMenu}}
                <span class="caret"></span>
              </button>
              <ul class="dropdown-menu">
                <li
                  :style="{backgroundColor: deleted ? '#fff' : '#f8f9fb'}"
                  @click="goToDashboard()"
                >Prizes</li>
                <li
                  :style="{backgroundColor: deleted ? '#f8f9fb' : '#fff'}"
                  @click="deletedPrizes()"
                >Deleted Prizes</li>
                <li @click="goToPublicDrawSettings()">Public Draw Settings</li>
              </ul>
            </span>
          </h1>
          <div class="desktop">
            <button class="btn btn-primary" @click="createPrizeScreen()">Create Prize</button>
          </div>
        </div>

        <div class="col-12 flex-table dashboard-prizes-table" :style="{opacity: loading ? 0 : 1}">
          <div class="flex-table-header d-flex align-items-center">
            <div class="column c-prize-name">Prize name</div>
            <div class="column c-status">status</div>
            <div class="column c-list desktop">list(s)</div>
            <div class="column c-winners desktop">winners</div>
            <!-- <div class="column c-attendees">attendees</div> -->
            <div class="column type-date c-created desktop">created on</div>
            <div class="column type-date c-modified desktop">modified on</div>
            <div class="column c-modified-by desktop">modified by</div>
            <div class="column c-action"></div>
          </div>
          <!-- vue repeat -->
          <template v-for="(prize,index) in prizes_list" v-if="prizes_list.length > 0">
            <PrizeTableRow
              :key="prize.prize_name"
              :prize="prize"
              :index="index"
              :deleted="deleted"
            />
          </template>
          <div class="empty-prize" v-if="prizes_list.length === 0">
            <img src="@/assets/images/cup.svg" alt>
            <p class="msg">
              You haven’t added any prize to this event yet.
              <br>Click
              <a href="#/create-prize">here</a> to add new Prize
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import PrizeTableRow from "@/components/PrizeTableRow";
import FullLoader from "@/components/FullLoader";
import axios from "axios";
import config from "@/config/config";
import { SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION } from "constants";
var $ = require("jquery");
var moment = require("moment");
export default {
  name: "DashboardContent",
  data() {
    return {
      dashboardLoading: true,
      eventDetailsLoading: true,
      prizes_list: [],
      eventDetail: { name: "Event" },
      currentUser: ""
    };
  },
  props: ["deleted"],
  computed: {
    prizeMenu() {
      return this.deleted ? "Deleted Prizes" : "Prizes";
    },
    loading() {
      return this.dashboardLoading || this.eventDetailsLoading;
    },
    gevmeLink() {
      return (
        config.redirectionBaseUrl +
        localStorage.getItem("org_id") +
        "/events/" +
        localStorage.getItem("event_id")
      );
    }
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
    Event.$on("Get Gevme Data", user => {
      this.currentUser = user.gevmeUser.id;
    });
    Event.$on("Gevme Event Detail", eve => {
      this.eventDetail = eve;
      this.eventDetailsLoading = false;
      localStorage.setItem("event_name", eve.name);
      localStorage.setItem("org_id", eve.organization_id);
      document.getElementsByTagName("title")[0].innerText = `${
        this.eventDetail.name
      } • GEVME Lucky Draw`;
    });
    Event.$on("Created Prize", prize => {
      this.prizes_list.push(prize);
    });
    Event.$on("Prize Deleted", id => {
      // this.prizes_list = this.prizes_list.filter(i => i.id !== id);
      this.prizes_list.filter(i => i.id == id)[0].deletedAt = moment().format(
        "MMM Do 'YY"
      );
    });
    Event.$on("Event ID Set", () => {
      this.getPrizes();
    });
  },
  components: {
    PrizeTableRow,
    FullLoader
  },
  methods: {
    createPrizeScreen() {
      this.$router.push({
        name: "CreatePrize",
        params: {
          prizeList: this.prizes_list
        }
      });
    },
    getPrizes() {
      axios
        .post(
          ENDPOINT,
          {
            query: `
              query {
                prizes(where: {eventId: "${localStorage.getItem(
                  "event_id"
                )}"}) {
                  id
                  eventId
                  winnerCount
                  name
                  drawn
                  draws {
                    status
                    position
                    selectedAttendee
                    doneBy {
                      gevmeUser
                    }
                  }
                  author {
                    id
                    gevmeUser
                  }
                  lists
                  excludePreviousWinners
                  exclusionScope
                  createdAt
                  updatedAt
                  deletedAt
                }
              }
            `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            this.dashboardLoading = false;
            response.data.data.prizes.forEach(element => {
              if (!element.drawn && element.draws.length > 0) {
                if (element.draws[0].doneBy.gevmeUser.id == this.currentUser) {
                  this.$router.push({
                    name: "PerformDraw",
                    params: {
                      prizeInfo: element
                    }
                  });
                  return;
                }
              }
              this.prizes_list.push(element);
            });
          }.bind(this)
        );
    },
    deletedPrizes() {
      this.$router.push({
        name: "DeletedPrizes",
        params: {
          deleted: true
        }
      });
    },
    goToDashboard() {
      this.$router.push({
        name: "Dashboard",
        params: {
          deleted: false
        }
      });
    },
    goToPublicDrawSettings() {
      this.$router.push({
        name: "PublicDrawSettings"
      });
    }
  }
};
</script>

<style scoped>
.header-action.back {
  width: 22px;
  height: 14px;
}

.dashboard-prizes-table {
  opacity: 1;
  transition: opacity 0.35s;
}

.btn.dropdown-toggle:focus {
  box-shadow: none;
}

.dropdown .dropdown-toggle::after {
  position: relative;
  top: 4px;
  right: 5px;
  border-radius: 3px;
  border-color: #000;
  border-right: 0.35em solid transparent;
  border-top: 0.35em solid #000;
  border-left: 0.35em solid transparent;
}

.dropdown.show .dropdown-toggle::after {
  border-top: 0;
  border-bottom: 0.35em solid #000;
}

ul.dropdown-menu {
  min-width: 11.6rem;
  padding: 0;
}

ul.dropdown-menu li {
  padding: 5px 15px;
  margin: 5px 0;
  color: #5e6977;
  font-size: 16px;
  cursor: pointer;
}

.mobile {
  display: none;
}

.mobile.create-prize-btn {
  text-align: center;
  margin-bottom: 25px;
}
@media screen and (max-width: 991px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}

@media screen and (max-width: 640px) {
  .page-header a.header-action {
    left: 14px;
  }

  .page-header {
    padding-left: 50px;
  }
}

@media screen and (min-width: 992px) and (max-width: 1024px) {
  .page-header a.header-action {
    left: 0;
  }

  .page-header {
    padding-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardContent.vue